import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { API_ENTITLEMENT_HOTLIST_TYPES } from '../../core/redux/api/endpoints';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import * as R from 'ramda';
import { EntitlementHotlistType } from './entitlementHotlistType';
import { assoc } from '../../language/module';


const KEY_ACTION = ACTION_TYPE.GET_ENTITLEMENT_HOTLIST_TYPES_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_ENTITLEMENT_HOTLIST_TYPES_REQUEST,
  ACTION_TYPE.GET_ENTITLEMENT_HOTLIST_TYPES_RESPONSE,
  ACTION_TYPE.GET_ENTITLEMENT_HOTLIST_TYPES_ERROR,
];


/**
 * Constructs an action that can be dispatched to get the complete list of hotlist types
 */
export const getHotlistTypesAction = () => makeApiAction(
  {
    method:   'GET',
    endpoint: API_ENTITLEMENT_HOTLIST_TYPES,
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS as RsaaTypes,
    bailout:  state => !!R.path([ 'entitlementHotlistTypes', 'isLoading' ], state) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<EntitlementHotlistType[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return assoc('entitlementHotlistTypes', { isLoading: true, error: undefined }, state);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return assoc('entitlementHotlistTypes', { isLoading: false, error: error }, withBreaker);
  }

  return assoc(
    'entitlementHotlistTypes',
    {
      isLoading: false,
      error:     undefined,
      types:   (payload || [])
    },
    withBreaker,
  );
};


export const getEntitlementHotlistTypesReducer = makeApiReducer<EntitlementHotlistType[]>(ACTIONS, KEY_ACTION, reducer);
